import React from 'react';
import { whatsIncluded } from '../../mock';
import { Sparkles, Globe2, Headset, CalendarHeart, Gem, BadgeCheck } from 'lucide-react';

const iconMap = { Sparkles, Globe2, Headset, CalendarHeart, Gem, BadgeCheck };

const WhatsIncluded = () => {
  return (
    <section id="included" className="bg-cream py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center reveal">
          <div className="gold-divider mb-5">
            <span className="chapter-badge text-gold uppercase">{whatsIncluded.eyebrow}</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            {whatsIncluded.headline}
          </h2>
          <p className="mt-4 font-serif-editorial text-navy/70 text-xl">{whatsIncluded.sub}</p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
          {whatsIncluded.items.map((it) => {
            const Icon = iconMap[it.icon] || Sparkles;
            return (
              <div key={it.title} className="reveal text-center">
                <div className="mx-auto w-14 h-14 flex items-center justify-center border border-gold/40 rounded-full">
                  <Icon size={22} className="text-gold" strokeWidth={1.4} />
                </div>
                <h3 className="mt-5 font-serif-display text-navy text-xl">{it.title}</h3>
                <p className="mt-2 font-sans-body text-navy/70 text-[0.95rem] leading-relaxed max-w-xs mx-auto">
                  {it.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatsIncluded;
